import React from 'react';

import { ThemeName } from '@opendoor/bricks/theme';

import PartnersPage from '../../components/partners/PartnersPage';
import Layout from '../../components/shared/Layout';
import ReduxWrapper from '../../components/shared/ReduxWrapper';

const Page: React.FC & { theme: ThemeName } = () => {
  return (
    <ReduxWrapper>
      <Layout>
        <PartnersPage partnerChannel="HOME_BUILDER" signUpRole="partner_sales_referrer" />
      </Layout>
    </ReduxWrapper>
  );
};

Page.theme = 'eero';

export default Page;
